import { render } from "./ManagementPotentialInstruction.vue?vue&type=template&id=1d5e3593&scoped=true"
import script from "./ManagementPotentialInstruction.vue?vue&type=script&lang=js"
export * from "./ManagementPotentialInstruction.vue?vue&type=script&lang=js"

import "./ManagementPotentialInstruction.vue?vue&type=style&index=0&id=1d5e3593&scoped=true&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5e3593"]])

export default __exports__